var _g, _path, _path2, _g2, _path3, _path4, _g3, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g4, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g5, _g6, _g7, _g8, _g9, _path35, _g10, _g11, _g12, _path36, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _path37, _g20, _path38, _g21, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInLotusPosition(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_715_15663)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5276 8.40356C20.662 8.12829 20.7324 7.82102 20.7324 7.50094C20.7324 7.20533 20.6716 6.92796 20.5625 6.67513H20.5659C20.515 6.56064 20.4578 6.45248 20.388 6.35063L20.3867 6.34865C20.1691 6.01577 20.0538 5.62527 20.0538 5.22837V5.22197C20.0538 4.06968 19.1192 3.13504 17.9669 3.13504C17.8517 3.13504 17.7429 3.08383 17.6788 2.98781C17.3011 2.46287 16.6801 2.11719 15.9823 2.11719C15.2846 2.11719 14.6636 2.46287 14.2859 2.98781C14.2219 3.07743 14.1131 3.13504 13.9978 3.13504C13.9799 3.13504 13.9619 3.13527 13.9441 3.13572C12.8166 3.16427 11.9109 4.08766 11.9109 5.22197V5.22837C11.9109 5.62527 11.7957 6.01577 11.578 6.34865L11.5766 6.35097C11.3599 6.68335 11.2324 7.07303 11.2324 7.50094C11.2324 7.82742 11.3092 8.12829 11.4373 8.40356C11.4821 8.49319 11.4821 8.60201 11.4373 8.69164C11.3092 8.9605 11.2324 9.26138 11.2324 9.58146C11.2324 10.7081 12.1414 11.6172 13.2681 11.6172H18.6967C19.8234 11.6172 20.7324 10.7081 20.7324 9.58146C20.7324 9.26138 20.6556 8.9605 20.5276 8.69164C20.4827 8.60201 20.4827 8.49319 20.5276 8.40356ZM12.7722 6.71309H12.7644L13.5226 8.20312C13.6006 9.9759 14.2925 8.20312 15.9823 8.20312C17.6722 8.20312 18.4091 10.1763 18.4871 8.40356L19.2056 6.38116C19.1716 5.59372 18.601 5.53845 18.4871 5.53845H16.4502C15.6459 5.53845 14.8869 5.14475 14.4328 4.47998C14.355 4.37026 14.1928 4.38963 14.1409 4.51225L14.089 4.63488C13.9463 4.98985 13.6739 5.26093 13.3365 5.41582C13.3268 5.41905 13.3155 5.42389 13.3041 5.42873C13.2928 5.43357 13.2814 5.43841 13.2717 5.44164C13.1225 5.51909 12.7722 5.75144 12.7592 6.35167L12.7657 6.54529L12.7722 6.71309Z",
    fill: "url(#paint0_linear_715_15663)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5276 8.40356C20.662 8.12829 20.7324 7.82102 20.7324 7.50094C20.7324 7.20533 20.6716 6.92796 20.5625 6.67513H20.5659C20.515 6.56064 20.4578 6.45248 20.388 6.35063L20.3867 6.34865C20.1691 6.01577 20.0538 5.62527 20.0538 5.22837V5.22197C20.0538 4.06968 19.1192 3.13504 17.9669 3.13504C17.8517 3.13504 17.7429 3.08383 17.6788 2.98781C17.3011 2.46287 16.6801 2.11719 15.9823 2.11719C15.2846 2.11719 14.6636 2.46287 14.2859 2.98781C14.2219 3.07743 14.1131 3.13504 13.9978 3.13504C13.9799 3.13504 13.9619 3.13527 13.9441 3.13572C12.8166 3.16427 11.9109 4.08766 11.9109 5.22197V5.22837C11.9109 5.62527 11.7957 6.01577 11.578 6.34865L11.5766 6.35097C11.3599 6.68335 11.2324 7.07303 11.2324 7.50094C11.2324 7.82742 11.3092 8.12829 11.4373 8.40356C11.4821 8.49319 11.4821 8.60201 11.4373 8.69164C11.3092 8.9605 11.2324 9.26138 11.2324 9.58146C11.2324 10.7081 12.1414 11.6172 13.2681 11.6172H18.6967C19.8234 11.6172 20.7324 10.7081 20.7324 9.58146C20.7324 9.26138 20.6556 8.9605 20.5276 8.69164C20.4827 8.60201 20.4827 8.49319 20.5276 8.40356ZM12.7722 6.71309H12.7644L13.5226 8.20312C13.6006 9.9759 14.2925 8.20312 15.9823 8.20312C17.6722 8.20312 18.4091 10.1763 18.4871 8.40356L19.2056 6.38116C19.1716 5.59372 18.601 5.53845 18.4871 5.53845H16.4502C15.6459 5.53845 14.8869 5.14475 14.4328 4.47998C14.355 4.37026 14.1928 4.38963 14.1409 4.51225L14.089 4.63488C13.9463 4.98985 13.6739 5.26093 13.3365 5.41582C13.3268 5.41905 13.3155 5.42389 13.3041 5.42873C13.2928 5.43357 13.2814 5.43841 13.2717 5.44164C13.1225 5.51909 12.7722 5.75144 12.7592 6.35167L12.7657 6.54529L12.7722 6.71309Z",
    fill: "url(#paint1_radial_715_15663)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5276 8.40356C20.662 8.12829 20.7324 7.82102 20.7324 7.50094C20.7324 7.20533 20.6716 6.92796 20.5625 6.67513H20.5659C20.515 6.56064 20.4578 6.45248 20.388 6.35063L20.3867 6.34865C20.1691 6.01577 20.0538 5.62527 20.0538 5.22837V5.22197C20.0538 4.06968 19.1192 3.13504 17.9669 3.13504C17.8517 3.13504 17.7429 3.08383 17.6788 2.98781C17.3011 2.46287 16.6801 2.11719 15.9823 2.11719C15.2846 2.11719 14.6636 2.46287 14.2859 2.98781C14.2219 3.07743 14.1131 3.13504 13.9978 3.13504C13.9799 3.13504 13.9619 3.13527 13.9441 3.13572C12.8166 3.16427 11.9109 4.08766 11.9109 5.22197V5.22837C11.9109 5.62527 11.7957 6.01577 11.578 6.34865L11.5766 6.35097C11.3599 6.68335 11.2324 7.07303 11.2324 7.50094C11.2324 7.82742 11.3092 8.12829 11.4373 8.40356C11.4821 8.49319 11.4821 8.60201 11.4373 8.69164C11.3092 8.9605 11.2324 9.26138 11.2324 9.58146C11.2324 10.7081 12.1414 11.6172 13.2681 11.6172H18.6967C19.8234 11.6172 20.7324 10.7081 20.7324 9.58146C20.7324 9.26138 20.6556 8.9605 20.5276 8.69164C20.4827 8.60201 20.4827 8.49319 20.5276 8.40356ZM12.7722 6.71309H12.7644L13.5226 8.20312C13.6006 9.9759 14.2925 8.20312 15.9823 8.20312C17.6722 8.20312 18.4091 10.1763 18.4871 8.40356L19.2056 6.38116C19.1716 5.59372 18.601 5.53845 18.4871 5.53845H16.4502C15.6459 5.53845 14.8869 5.14475 14.4328 4.47998C14.355 4.37026 14.1928 4.38963 14.1409 4.51225L14.089 4.63488C13.9463 4.98985 13.6739 5.26093 13.3365 5.41582C13.3268 5.41905 13.3155 5.42389 13.3041 5.42873C13.2928 5.43357 13.2814 5.43841 13.2717 5.44164C13.1225 5.51909 12.7722 5.75144 12.7592 6.35167L12.7657 6.54529L12.7722 6.71309Z",
    fill: "url(#paint2_radial_715_15663)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5276 8.40356C20.662 8.12829 20.7324 7.82102 20.7324 7.50094C20.7324 7.20533 20.6716 6.92796 20.5625 6.67513H20.5659C20.515 6.56064 20.4578 6.45248 20.388 6.35063L20.3867 6.34865C20.1691 6.01577 20.0538 5.62527 20.0538 5.22837V5.22197C20.0538 4.06968 19.1192 3.13504 17.9669 3.13504C17.8517 3.13504 17.7429 3.08383 17.6788 2.98781C17.3011 2.46287 16.6801 2.11719 15.9823 2.11719C15.2846 2.11719 14.6636 2.46287 14.2859 2.98781C14.2219 3.07743 14.1131 3.13504 13.9978 3.13504C13.9799 3.13504 13.9619 3.13527 13.9441 3.13572C12.8166 3.16427 11.9109 4.08766 11.9109 5.22197V5.22837C11.9109 5.62527 11.7957 6.01577 11.578 6.34865L11.5766 6.35097C11.3599 6.68335 11.2324 7.07303 11.2324 7.50094C11.2324 7.82742 11.3092 8.12829 11.4373 8.40356C11.4821 8.49319 11.4821 8.60201 11.4373 8.69164C11.3092 8.9605 11.2324 9.26138 11.2324 9.58146C11.2324 10.7081 12.1414 11.6172 13.2681 11.6172H18.6967C19.8234 11.6172 20.7324 10.7081 20.7324 9.58146C20.7324 9.26138 20.6556 8.9605 20.5276 8.69164C20.4827 8.60201 20.4827 8.49319 20.5276 8.40356ZM12.7722 6.71309H12.7644L13.5226 8.20312C13.6006 9.9759 14.2925 8.20312 15.9823 8.20312C17.6722 8.20312 18.4091 10.1763 18.4871 8.40356L19.2056 6.38116C19.1716 5.59372 18.601 5.53845 18.4871 5.53845H16.4502C15.6459 5.53845 14.8869 5.14475 14.4328 4.47998C14.355 4.37026 14.1928 4.38963 14.1409 4.51225L14.089 4.63488C13.9463 4.98985 13.6739 5.26093 13.3365 5.41582C13.3268 5.41905 13.3155 5.42389 13.3041 5.42873C13.2928 5.43357 13.2814 5.43841 13.2717 5.44164C13.1225 5.51909 12.7722 5.75144 12.7592 6.35167L12.7657 6.54529L12.7722 6.71309Z",
    fill: "url(#paint3_radial_715_15663)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5276 8.40356C20.662 8.12829 20.7324 7.82102 20.7324 7.50094C20.7324 7.20533 20.6716 6.92796 20.5625 6.67513H20.5659C20.515 6.56064 20.4578 6.45248 20.388 6.35063L20.3867 6.34865C20.1691 6.01577 20.0538 5.62527 20.0538 5.22837V5.22197C20.0538 4.06968 19.1192 3.13504 17.9669 3.13504C17.8517 3.13504 17.7429 3.08383 17.6788 2.98781C17.3011 2.46287 16.6801 2.11719 15.9823 2.11719C15.2846 2.11719 14.6636 2.46287 14.2859 2.98781C14.2219 3.07743 14.1131 3.13504 13.9978 3.13504C13.9799 3.13504 13.9619 3.13527 13.9441 3.13572C12.8166 3.16427 11.9109 4.08766 11.9109 5.22197V5.22837C11.9109 5.62527 11.7957 6.01577 11.578 6.34865L11.5766 6.35097C11.3599 6.68335 11.2324 7.07303 11.2324 7.50094C11.2324 7.82742 11.3092 8.12829 11.4373 8.40356C11.4821 8.49319 11.4821 8.60201 11.4373 8.69164C11.3092 8.9605 11.2324 9.26138 11.2324 9.58146C11.2324 10.7081 12.1414 11.6172 13.2681 11.6172H18.6967C19.8234 11.6172 20.7324 10.7081 20.7324 9.58146C20.7324 9.26138 20.6556 8.9605 20.5276 8.69164C20.4827 8.60201 20.4827 8.49319 20.5276 8.40356ZM12.7722 6.71309H12.7644L13.5226 8.20312C13.6006 9.9759 14.2925 8.20312 15.9823 8.20312C17.6722 8.20312 18.4091 10.1763 18.4871 8.40356L19.2056 6.38116C19.1716 5.59372 18.601 5.53845 18.4871 5.53845H16.4502C15.6459 5.53845 14.8869 5.14475 14.4328 4.47998C14.355 4.37026 14.1928 4.38963 14.1409 4.51225L14.089 4.63488C13.9463 4.98985 13.6739 5.26093 13.3365 5.41582C13.3268 5.41905 13.3155 5.42389 13.3041 5.42873C13.2928 5.43357 13.2814 5.43841 13.2717 5.44164C13.1225 5.51909 12.7722 5.75144 12.7592 6.35167L12.7657 6.54529L12.7722 6.71309Z",
    fill: "url(#paint4_radial_715_15663)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5276 8.40356C20.662 8.12829 20.7324 7.82102 20.7324 7.50094C20.7324 7.20533 20.6716 6.92796 20.5625 6.67513H20.5659C20.515 6.56064 20.4578 6.45248 20.388 6.35063L20.3867 6.34865C20.1691 6.01577 20.0538 5.62527 20.0538 5.22837V5.22197C20.0538 4.06968 19.1192 3.13504 17.9669 3.13504C17.8517 3.13504 17.7429 3.08383 17.6788 2.98781C17.3011 2.46287 16.6801 2.11719 15.9823 2.11719C15.2846 2.11719 14.6636 2.46287 14.2859 2.98781C14.2219 3.07743 14.1131 3.13504 13.9978 3.13504C13.9799 3.13504 13.9619 3.13527 13.9441 3.13572C12.8166 3.16427 11.9109 4.08766 11.9109 5.22197V5.22837C11.9109 5.62527 11.7957 6.01577 11.578 6.34865L11.5766 6.35097C11.3599 6.68335 11.2324 7.07303 11.2324 7.50094C11.2324 7.82742 11.3092 8.12829 11.4373 8.40356C11.4821 8.49319 11.4821 8.60201 11.4373 8.69164C11.3092 8.9605 11.2324 9.26138 11.2324 9.58146C11.2324 10.7081 12.1414 11.6172 13.2681 11.6172H18.6967C19.8234 11.6172 20.7324 10.7081 20.7324 9.58146C20.7324 9.26138 20.6556 8.9605 20.5276 8.69164C20.4827 8.60201 20.4827 8.49319 20.5276 8.40356ZM12.7722 6.71309H12.7644L13.5226 8.20312C13.6006 9.9759 14.2925 8.20312 15.9823 8.20312C17.6722 8.20312 18.4091 10.1763 18.4871 8.40356L19.2056 6.38116C19.1716 5.59372 18.601 5.53845 18.4871 5.53845H16.4502C15.6459 5.53845 14.8869 5.14475 14.4328 4.47998C14.355 4.37026 14.1928 4.38963 14.1409 4.51225L14.089 4.63488C13.9463 4.98985 13.6739 5.26093 13.3365 5.41582C13.3268 5.41905 13.3155 5.42389 13.3041 5.42873C13.2928 5.43357 13.2814 5.43841 13.2717 5.44164C13.1225 5.51909 12.7722 5.75144 12.7592 6.35167L12.7657 6.54529L12.7722 6.71309Z",
    fill: "url(#paint5_radial_715_15663)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5276 8.40356C20.662 8.12829 20.7324 7.82102 20.7324 7.50094C20.7324 7.20533 20.6716 6.92796 20.5625 6.67513H20.5659C20.515 6.56064 20.4578 6.45248 20.388 6.35063L20.3867 6.34865C20.1691 6.01577 20.0538 5.62527 20.0538 5.22837V5.22197C20.0538 4.06968 19.1192 3.13504 17.9669 3.13504C17.8517 3.13504 17.7429 3.08383 17.6788 2.98781C17.3011 2.46287 16.6801 2.11719 15.9823 2.11719C15.2846 2.11719 14.6636 2.46287 14.2859 2.98781C14.2219 3.07743 14.1131 3.13504 13.9978 3.13504C13.9799 3.13504 13.9619 3.13527 13.9441 3.13572C12.8166 3.16427 11.9109 4.08766 11.9109 5.22197V5.22837C11.9109 5.62527 11.7957 6.01577 11.578 6.34865L11.5766 6.35097C11.3599 6.68335 11.2324 7.07303 11.2324 7.50094C11.2324 7.82742 11.3092 8.12829 11.4373 8.40356C11.4821 8.49319 11.4821 8.60201 11.4373 8.69164C11.3092 8.9605 11.2324 9.26138 11.2324 9.58146C11.2324 10.7081 12.1414 11.6172 13.2681 11.6172H18.6967C19.8234 11.6172 20.7324 10.7081 20.7324 9.58146C20.7324 9.26138 20.6556 8.9605 20.5276 8.69164C20.4827 8.60201 20.4827 8.49319 20.5276 8.40356ZM12.7722 6.71309H12.7644L13.5226 8.20312C13.6006 9.9759 14.2925 8.20312 15.9823 8.20312C17.6722 8.20312 18.4091 10.1763 18.4871 8.40356L19.2056 6.38116C19.1716 5.59372 18.601 5.53845 18.4871 5.53845H16.4502C15.6459 5.53845 14.8869 5.14475 14.4328 4.47998C14.355 4.37026 14.1928 4.38963 14.1409 4.51225L14.089 4.63488C13.9463 4.98985 13.6739 5.26093 13.3365 5.41582C13.3268 5.41905 13.3155 5.42389 13.3041 5.42873C13.2928 5.43357 13.2814 5.43841 13.2717 5.44164C13.1225 5.51909 12.7722 5.75144 12.7592 6.35167L12.7657 6.54529L12.7722 6.71309Z",
    fill: "url(#paint6_radial_715_15663)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5276 8.40356C20.662 8.12829 20.7324 7.82102 20.7324 7.50094C20.7324 7.20533 20.6716 6.92796 20.5625 6.67513H20.5659C20.515 6.56064 20.4578 6.45248 20.388 6.35063L20.3867 6.34865C20.1691 6.01577 20.0538 5.62527 20.0538 5.22837V5.22197C20.0538 4.06968 19.1192 3.13504 17.9669 3.13504C17.8517 3.13504 17.7429 3.08383 17.6788 2.98781C17.3011 2.46287 16.6801 2.11719 15.9823 2.11719C15.2846 2.11719 14.6636 2.46287 14.2859 2.98781C14.2219 3.07743 14.1131 3.13504 13.9978 3.13504C13.9799 3.13504 13.9619 3.13527 13.9441 3.13572C12.8166 3.16427 11.9109 4.08766 11.9109 5.22197V5.22837C11.9109 5.62527 11.7957 6.01577 11.578 6.34865L11.5766 6.35097C11.3599 6.68335 11.2324 7.07303 11.2324 7.50094C11.2324 7.82742 11.3092 8.12829 11.4373 8.40356C11.4821 8.49319 11.4821 8.60201 11.4373 8.69164C11.3092 8.9605 11.2324 9.26138 11.2324 9.58146C11.2324 10.7081 12.1414 11.6172 13.2681 11.6172H18.6967C19.8234 11.6172 20.7324 10.7081 20.7324 9.58146C20.7324 9.26138 20.6556 8.9605 20.5276 8.69164C20.4827 8.60201 20.4827 8.49319 20.5276 8.40356ZM12.7722 6.71309H12.7644L13.5226 8.20312C13.6006 9.9759 14.2925 8.20312 15.9823 8.20312C17.6722 8.20312 18.4091 10.1763 18.4871 8.40356L19.2056 6.38116C19.1716 5.59372 18.601 5.53845 18.4871 5.53845H16.4502C15.6459 5.53845 14.8869 5.14475 14.4328 4.47998C14.355 4.37026 14.1928 4.38963 14.1409 4.51225L14.089 4.63488C13.9463 4.98985 13.6739 5.26093 13.3365 5.41582C13.3268 5.41905 13.3155 5.42389 13.3041 5.42873C13.2928 5.43357 13.2814 5.43841 13.2717 5.44164C13.1225 5.51909 12.7722 5.75144 12.7592 6.35167L12.7657 6.54529L12.7722 6.71309Z",
    fill: "url(#paint7_radial_715_15663)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5276 8.40356C20.662 8.12829 20.7324 7.82102 20.7324 7.50094C20.7324 7.20533 20.6716 6.92796 20.5625 6.67513H20.5659C20.515 6.56064 20.4578 6.45248 20.388 6.35063L20.3867 6.34865C20.1691 6.01577 20.0538 5.62527 20.0538 5.22837V5.22197C20.0538 4.06968 19.1192 3.13504 17.9669 3.13504C17.8517 3.13504 17.7429 3.08383 17.6788 2.98781C17.3011 2.46287 16.6801 2.11719 15.9823 2.11719C15.2846 2.11719 14.6636 2.46287 14.2859 2.98781C14.2219 3.07743 14.1131 3.13504 13.9978 3.13504C13.9799 3.13504 13.9619 3.13527 13.9441 3.13572C12.8166 3.16427 11.9109 4.08766 11.9109 5.22197V5.22837C11.9109 5.62527 11.7957 6.01577 11.578 6.34865L11.5766 6.35097C11.3599 6.68335 11.2324 7.07303 11.2324 7.50094C11.2324 7.82742 11.3092 8.12829 11.4373 8.40356C11.4821 8.49319 11.4821 8.60201 11.4373 8.69164C11.3092 8.9605 11.2324 9.26138 11.2324 9.58146C11.2324 10.7081 12.1414 11.6172 13.2681 11.6172H18.6967C19.8234 11.6172 20.7324 10.7081 20.7324 9.58146C20.7324 9.26138 20.6556 8.9605 20.5276 8.69164C20.4827 8.60201 20.4827 8.49319 20.5276 8.40356ZM12.7722 6.71309H12.7644L13.5226 8.20312C13.6006 9.9759 14.2925 8.20312 15.9823 8.20312C17.6722 8.20312 18.4091 10.1763 18.4871 8.40356L19.2056 6.38116C19.1716 5.59372 18.601 5.53845 18.4871 5.53845H16.4502C15.6459 5.53845 14.8869 5.14475 14.4328 4.47998C14.355 4.37026 14.1928 4.38963 14.1409 4.51225L14.089 4.63488C13.9463 4.98985 13.6739 5.26093 13.3365 5.41582C13.3268 5.41905 13.3155 5.42389 13.3041 5.42873C13.2928 5.43357 13.2814 5.43841 13.2717 5.44164C13.1225 5.51909 12.7722 5.75144 12.7592 6.35167L12.7657 6.54529L12.7722 6.71309Z",
    fill: "url(#paint8_radial_715_15663)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5276 8.40356C20.662 8.12829 20.7324 7.82102 20.7324 7.50094C20.7324 7.20533 20.6716 6.92796 20.5625 6.67513H20.5659C20.515 6.56064 20.4578 6.45248 20.388 6.35063L20.3867 6.34865C20.1691 6.01577 20.0538 5.62527 20.0538 5.22837V5.22197C20.0538 4.06968 19.1192 3.13504 17.9669 3.13504C17.8517 3.13504 17.7429 3.08383 17.6788 2.98781C17.3011 2.46287 16.6801 2.11719 15.9823 2.11719C15.2846 2.11719 14.6636 2.46287 14.2859 2.98781C14.2219 3.07743 14.1131 3.13504 13.9978 3.13504C13.9799 3.13504 13.9619 3.13527 13.9441 3.13572C12.8166 3.16427 11.9109 4.08766 11.9109 5.22197V5.22837C11.9109 5.62527 11.7957 6.01577 11.578 6.34865L11.5766 6.35097C11.3599 6.68335 11.2324 7.07303 11.2324 7.50094C11.2324 7.82742 11.3092 8.12829 11.4373 8.40356C11.4821 8.49319 11.4821 8.60201 11.4373 8.69164C11.3092 8.9605 11.2324 9.26138 11.2324 9.58146C11.2324 10.7081 12.1414 11.6172 13.2681 11.6172H18.6967C19.8234 11.6172 20.7324 10.7081 20.7324 9.58146C20.7324 9.26138 20.6556 8.9605 20.5276 8.69164C20.4827 8.60201 20.4827 8.49319 20.5276 8.40356ZM12.7722 6.71309H12.7644L13.5226 8.20312C13.6006 9.9759 14.2925 8.20312 15.9823 8.20312C17.6722 8.20312 18.4091 10.1763 18.4871 8.40356L19.2056 6.38116C19.1716 5.59372 18.601 5.53845 18.4871 5.53845H16.4502C15.6459 5.53845 14.8869 5.14475 14.4328 4.47998C14.355 4.37026 14.1928 4.38963 14.1409 4.51225L14.089 4.63488C13.9463 4.98985 13.6739 5.26093 13.3365 5.41582C13.3268 5.41905 13.3155 5.42389 13.3041 5.42873C13.2928 5.43357 13.2814 5.43841 13.2717 5.44164C13.1225 5.51909 12.7722 5.75144 12.7592 6.35167L12.7657 6.54529L12.7722 6.71309Z",
    fill: "url(#paint9_radial_715_15663)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5276 8.40356C20.662 8.12829 20.7324 7.82102 20.7324 7.50094C20.7324 7.20533 20.6716 6.92796 20.5625 6.67513H20.5659C20.515 6.56064 20.4578 6.45248 20.388 6.35063L20.3867 6.34865C20.1691 6.01577 20.0538 5.62527 20.0538 5.22837V5.22197C20.0538 4.06968 19.1192 3.13504 17.9669 3.13504C17.8517 3.13504 17.7429 3.08383 17.6788 2.98781C17.3011 2.46287 16.6801 2.11719 15.9823 2.11719C15.2846 2.11719 14.6636 2.46287 14.2859 2.98781C14.2219 3.07743 14.1131 3.13504 13.9978 3.13504C13.9799 3.13504 13.9619 3.13527 13.9441 3.13572C12.8166 3.16427 11.9109 4.08766 11.9109 5.22197V5.22837C11.9109 5.62527 11.7957 6.01577 11.578 6.34865L11.5766 6.35097C11.3599 6.68335 11.2324 7.07303 11.2324 7.50094C11.2324 7.82742 11.3092 8.12829 11.4373 8.40356C11.4821 8.49319 11.4821 8.60201 11.4373 8.69164C11.3092 8.9605 11.2324 9.26138 11.2324 9.58146C11.2324 10.7081 12.1414 11.6172 13.2681 11.6172H18.6967C19.8234 11.6172 20.7324 10.7081 20.7324 9.58146C20.7324 9.26138 20.6556 8.9605 20.5276 8.69164C20.4827 8.60201 20.4827 8.49319 20.5276 8.40356ZM12.7722 6.71309H12.7644L13.5226 8.20312C13.6006 9.9759 14.2925 8.20312 15.9823 8.20312C17.6722 8.20312 18.4091 10.1763 18.4871 8.40356L19.2056 6.38116C19.1716 5.59372 18.601 5.53845 18.4871 5.53845H16.4502C15.6459 5.53845 14.8869 5.14475 14.4328 4.47998C14.355 4.37026 14.1928 4.38963 14.1409 4.51225L14.089 4.63488C13.9463 4.98985 13.6739 5.26093 13.3365 5.41582C13.3268 5.41905 13.3155 5.42389 13.3041 5.42873C13.2928 5.43357 13.2814 5.43841 13.2717 5.44164C13.1225 5.51909 12.7722 5.75144 12.7592 6.35167L12.7657 6.54529L12.7722 6.71309Z",
    fill: "url(#paint10_radial_715_15663)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.7224 23.0632C6.7224 23.3394 6.49854 23.5632 6.2224 23.5632C5.59059 23.5632 4.96542 23.3702 4.72167 23.295C4.70726 23.2906 4.69419 23.2865 4.68252 23.283C4.41841 23.2024 4.26965 22.9229 4.35026 22.6588C4.43087 22.3947 4.71033 22.2459 4.97444 22.3265C4.98377 22.3294 4.99354 22.3324 5.00374 22.3355C5.25011 22.411 5.74718 22.5632 6.2224 22.5632C6.49854 22.5632 6.7224 22.7871 6.7224 23.0632Z",
    fill: "url(#paint11_radial_715_15663)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2776 23.0632C25.2776 23.3394 25.5015 23.5632 25.7776 23.5632C26.4094 23.5632 27.0346 23.3702 27.2783 23.295C27.2927 23.2906 27.3058 23.2865 27.3175 23.283C27.5816 23.2024 27.7304 22.9229 27.6497 22.6588C27.5691 22.3947 27.2897 22.2459 27.0256 22.3265C27.0162 22.3294 27.0065 22.3324 26.9963 22.3355C26.7499 22.411 26.2528 22.5632 25.7776 22.5632C25.5015 22.5632 25.2776 22.7871 25.2776 23.0632Z",
    fill: "url(#paint12_radial_715_15663)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_715_15663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5898 28.0437H21.834C24.7637 28.0437 26.1152 26.127 26.3184 25.2156L23.7871 22.8875L20.168 24.3093L17.5898 24.4187V28.0437Z",
    fill: "url(#paint13_radial_715_15663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5898 28.0437H21.834C24.7637 28.0437 26.1152 26.127 26.3184 25.2156L23.7871 22.8875L20.168 24.3093L17.5898 24.4187V28.0437Z",
    fill: "url(#paint14_radial_715_15663)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1835 24.4187H11.7549C11.3296 24.4187 10.951 24.6872 10.8112 25.0888C10.4037 26.2593 9.85136 27.8533 9.77916 28.0906C9.66978 28.45 9.52916 29.5437 10.6542 29.8562C11.411 30.0664 12.1339 28.9853 12.7115 28.1214C12.729 28.0953 12.7463 28.0694 12.7635 28.0437H13.1835V24.4187Z",
    fill: "url(#paint15_radial_715_15663)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1835 24.4187H11.7549C11.3296 24.4187 10.951 24.6872 10.8112 25.0888C10.4037 26.2593 9.85136 27.8533 9.77916 28.0906C9.66978 28.45 9.52916 29.5437 10.6542 29.8562C11.411 30.0664 12.1339 28.9853 12.7115 28.1214C12.729 28.0953 12.7463 28.0694 12.7635 28.0437H13.1835V24.4187Z",
    fill: "url(#paint16_radial_715_15663)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_715_15663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1992 28.0437C7.26953 28.0437 5.91797 26.127 5.71484 25.2156L8.24609 22.8875L11.6992 24.3328L19.8797 24.4187C20.305 24.4187 20.6836 24.6872 20.8234 25.0888C21.2309 26.2593 21.7833 27.8533 21.8555 28.0906C21.9648 28.45 22.1055 29.5437 20.9805 29.8562C20.2008 30.0728 19.457 28.9187 18.8711 28.0437H10.1992Z",
    fill: "#FFCB22"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1992 28.0437C7.26953 28.0437 5.91797 26.127 5.71484 25.2156L8.24609 22.8875L11.6992 24.3328L19.8797 24.4187C20.305 24.4187 20.6836 24.6872 20.8234 25.0888C21.2309 26.2593 21.7833 27.8533 21.8555 28.0906C21.9648 28.45 22.1055 29.5437 20.9805 29.8562C20.2008 30.0728 19.457 28.9187 18.8711 28.0437H10.1992Z",
    fill: "url(#paint17_radial_715_15663)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1992 28.0437C7.26953 28.0437 5.91797 26.127 5.71484 25.2156L8.24609 22.8875L11.6992 24.3328L19.8797 24.4187C20.305 24.4187 20.6836 24.6872 20.8234 25.0888C21.2309 26.2593 21.7833 27.8533 21.8555 28.0906C21.9648 28.45 22.1055 29.5437 20.9805 29.8562C20.2008 30.0728 19.457 28.9187 18.8711 28.0437H10.1992Z",
    fill: "url(#paint18_radial_715_15663)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4805 21.4292H24.4961V24.1218C21.9648 24.4734 18.4805 24.4187 18.4805 24.4187V21.4292Z",
    fill: "url(#paint19_radial_715_15663)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4805 21.4292H24.4961V24.1218C21.9648 24.4734 18.4805 24.4187 18.4805 24.4187V21.4292Z",
    fill: "url(#paint20_linear_715_15663)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4805 21.4292H24.4961V24.1218C21.9648 24.4734 18.4805 24.4187 18.4805 24.4187V21.4292Z",
    fill: "url(#paint21_linear_715_15663)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.793 21.4292H7.77734V24.1218C10.3086 24.4734 13.793 24.4187 13.793 24.4187V21.4292Z",
    fill: "url(#paint22_radial_715_15663)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.793 21.4292H7.77734V24.1218C10.3086 24.4734 13.793 24.4187 13.793 24.4187V21.4292Z",
    fill: "url(#paint23_linear_715_15663)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.793 21.4292H7.77734V24.1218C10.3086 24.4734 13.793 24.4187 13.793 24.4187V21.4292Z",
    fill: "url(#paint24_linear_715_15663)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71678 16.1867C9.9368 14.3284 11.3222 12.6063 11.8691 12.1453L12.2012 12.4603V19.7364C11.9512 20.3879 11.4824 21.0656 11.0762 21.3883C11.0762 21.3883 10.2092 22.2027 6.90455 24.6921C5.57955 24.5077 4.80973 23.5986 4.83057 22.989C5.70546 22.4896 8.20161 20.0207 8.84201 19.383C9.3791 18.8481 9.48219 18.1681 9.71678 16.1867Z",
    fill: "#F4AC2D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71678 16.1867C9.9368 14.3284 11.3222 12.6063 11.8691 12.1453L12.2012 12.4603V19.7364C11.9512 20.3879 11.4824 21.0656 11.0762 21.3883C11.0762 21.3883 10.2092 22.2027 6.90455 24.6921C5.57955 24.5077 4.80973 23.5986 4.83057 22.989C5.70546 22.4896 8.20161 20.0207 8.84201 19.383C9.3791 18.8481 9.48219 18.1681 9.71678 16.1867Z",
    fill: "url(#paint25_linear_715_15663)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71678 16.1867C9.9368 14.3284 11.3222 12.6063 11.8691 12.1453L12.2012 12.4603V19.7364C11.9512 20.3879 11.4824 21.0656 11.0762 21.3883C11.0762 21.3883 10.2092 22.2027 6.90455 24.6921C5.57955 24.5077 4.80973 23.5986 4.83057 22.989C5.70546 22.4896 8.20161 20.0207 8.84201 19.383C9.3791 18.8481 9.48219 18.1681 9.71678 16.1867Z",
    fill: "url(#paint26_radial_715_15663)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71678 16.1867C9.9368 14.3284 11.3222 12.6063 11.8691 12.1453L12.2012 12.4603V19.7364C11.9512 20.3879 11.4824 21.0656 11.0762 21.3883C11.0762 21.3883 10.2092 22.2027 6.90455 24.6921C5.57955 24.5077 4.80973 23.5986 4.83057 22.989C5.70546 22.4896 8.20161 20.0207 8.84201 19.383C9.3791 18.8481 9.48219 18.1681 9.71678 16.1867Z",
    fill: "url(#paint27_radial_715_15663)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2832 16.1867C22.0632 14.3284 20.6778 12.6063 20.1309 12.1453L19.7988 12.4603V19.7364C20.0488 20.3879 20.5176 21.0656 20.9238 21.3883C20.9238 21.3883 21.7908 22.2027 25.0955 24.6921C26.4205 24.5077 27.1903 23.5986 27.1694 22.989C26.2945 22.4896 23.7984 20.0207 23.158 19.383C22.6209 18.8481 22.5178 18.1681 22.2832 16.1867Z",
    fill: "#FCA512"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2832 16.1867C22.0632 14.3284 20.6778 12.6063 20.1309 12.1453L19.7988 12.4603V19.7364C20.0488 20.3879 20.5176 21.0656 20.9238 21.3883C20.9238 21.3883 21.7908 22.2027 25.0955 24.6921C26.4205 24.5077 27.1903 23.5986 27.1694 22.989C26.2945 22.4896 23.7984 20.0207 23.158 19.383C22.6209 18.8481 22.5178 18.1681 22.2832 16.1867Z",
    fill: "url(#paint28_linear_715_15663)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2832 16.1867C22.0632 14.3284 20.6778 12.6063 20.1309 12.1453L19.7988 12.4603V19.7364C20.0488 20.3879 20.5176 21.0656 20.9238 21.3883C20.9238 21.3883 21.7908 22.2027 25.0955 24.6921C26.4205 24.5077 27.1903 23.5986 27.1694 22.989C26.2945 22.4896 23.7984 20.0207 23.158 19.383C22.6209 18.8481 22.5178 18.1681 22.2832 16.1867Z",
    fill: "url(#paint29_radial_715_15663)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2832 16.1867C22.0632 14.3284 20.6778 12.6063 20.1309 12.1453L19.7988 12.4603V19.7364C20.0488 20.3879 20.5176 21.0656 20.9238 21.3883C20.9238 21.3883 21.7908 22.2027 25.0955 24.6921C26.4205 24.5077 27.1903 23.5986 27.1694 22.989C26.2945 22.4896 23.7984 20.0207 23.158 19.383C22.6209 18.8481 22.5178 18.1681 22.2832 16.1867Z",
    fill: "url(#paint30_radial_715_15663)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2832 16.1867C22.0632 14.3284 20.6778 12.6063 20.1309 12.1453L19.7988 12.4603V19.7364C20.0488 20.3879 20.5176 21.0656 20.9238 21.3883C20.9238 21.3883 21.7908 22.2027 25.0955 24.6921C26.4205 24.5077 27.1903 23.5986 27.1694 22.989C26.2945 22.4896 23.7984 20.0207 23.158 19.383C22.6209 18.8481 22.5178 18.1681 22.2832 16.1867Z",
    fill: "url(#paint31_radial_715_15663)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_715_15663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4102 24.4187L11.832 21.4292H20.1337L18.582 24.4187H13.4102Z",
    fill: "url(#paint32_radial_715_15663)"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8555 11.2593V11.9812C18.8555 13.3619 17.7362 14.4812 16.3555 14.4812H15.6211C14.2404 14.4812 13.1211 13.3619 13.1211 11.9812V11.2577C13.8842 10.8408 14.8913 10.4734 16.0352 10.4734C17.0855 10.4734 18.0907 10.8481 18.8555 11.2593Z",
    fill: "url(#paint33_radial_715_15663)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8555 11.2593V11.9812C18.8555 13.3619 17.7362 14.4812 16.3555 14.4812H15.6211C14.2404 14.4812 13.1211 13.3619 13.1211 11.9812V11.2577C13.8842 10.8408 14.8913 10.4734 16.0352 10.4734C17.0855 10.4734 18.0907 10.8481 18.8555 11.2593Z",
    fill: "url(#paint34_radial_715_15663)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8555 11.2594V11.9813C18.8555 13.3621 17.7362 14.4813 16.3555 14.4813H15.6211C14.2404 14.4813 13.1211 13.3621 13.1211 11.9813V11.2578C12.5414 11.5745 12.1025 11.9197 11.8516 12.154V21.4293H20.1403V12.154C19.9423 11.9537 19.4787 11.5945 18.8555 11.2594Z",
    fill: "url(#paint35_radial_715_15663)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8555 11.2594V11.9813C18.8555 13.3621 17.7362 14.4813 16.3555 14.4813H15.6211C14.2404 14.4813 13.1211 13.3621 13.1211 11.9813V11.2578C12.5414 11.5745 12.1025 11.9197 11.8516 12.154V21.4293H20.1403V12.154C19.9423 11.9537 19.4787 11.5945 18.8555 11.2594Z",
    fill: "url(#paint36_radial_715_15663)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8555 11.2594V11.9813C18.8555 13.3621 17.7362 14.4813 16.3555 14.4813H15.6211C14.2404 14.4813 13.1211 13.3621 13.1211 11.9813V11.2578C12.5414 11.5745 12.1025 11.9197 11.8516 12.154V21.4293H20.1403V12.154C19.9423 11.9537 19.4787 11.5945 18.8555 11.2594Z",
    fill: "url(#paint37_radial_715_15663)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.65944 23.1534C5.7241 23.3646 5.60528 23.5883 5.39404 23.6529C4.85802 23.817 4.29537 23.7988 4.0272 23.7901C3.97286 23.7883 3.93062 23.7869 3.90313 23.7876C3.68227 23.7925 3.49921 23.6175 3.49424 23.3966C3.48928 23.1758 3.6643 22.9927 3.88516 22.9878C3.95342 22.9862 4.03046 22.9882 4.11468 22.9904C4.4011 22.9977 4.77055 23.0072 5.15987 22.888C5.37111 22.8233 5.59477 22.9421 5.65944 23.1534Z",
    fill: "url(#paint38_radial_715_15663)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3406 23.1534C26.2759 23.3646 26.3947 23.5883 26.606 23.6529C27.142 23.817 27.7046 23.7988 27.9728 23.7901C28.0271 23.7883 28.0694 23.7869 28.0969 23.7876C28.3177 23.7925 28.5008 23.6175 28.5058 23.3966C28.5107 23.1758 28.3357 22.9927 28.1148 22.9878C28.0466 22.9862 27.9695 22.9882 27.8853 22.9904C27.5989 22.9977 27.2295 23.0072 26.8401 22.888C26.6289 22.8233 26.4052 22.9421 26.3406 23.1534Z",
    fill: "url(#paint39_radial_715_15663)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.78748 23.6314C5.88582 23.8293 5.80518 24.0693 5.60736 24.1677C4.85422 24.5421 4.09796 24.6158 3.78477 24.6158C3.56385 24.6158 3.38477 24.4367 3.38477 24.2158C3.38477 23.9948 3.56385 23.8158 3.78477 23.8158C4.01063 23.8158 4.63718 23.7566 5.25123 23.4513C5.44905 23.353 5.68913 23.4336 5.78748 23.6314Z",
    fill: "url(#paint40_radial_715_15663)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2125 23.6314C26.1142 23.8293 26.1948 24.0693 26.3926 24.1677C27.1458 24.5421 27.902 24.6158 28.2152 24.6158C28.4361 24.6158 28.6152 24.4367 28.6152 24.2158C28.6152 23.9948 28.4361 23.8158 28.2152 23.8158C27.9894 23.8158 27.3628 23.7566 26.7488 23.4513C26.551 23.353 26.3109 23.4336 26.2125 23.6314Z",
    fill: "url(#paint41_radial_715_15663)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.06141 24.0533C6.20501 24.2212 6.18532 24.4737 6.01744 24.6173C5.67855 24.9072 5.3897 25.0734 5.11448 25.1664C4.8606 25.2522 4.63704 25.2677 4.45945 25.2801C4.44696 25.2809 4.43469 25.2818 4.42266 25.2826C4.2023 25.2984 4.01091 25.1325 3.99517 24.9121C3.97943 24.6918 4.14531 24.5004 4.36566 24.4847C4.37181 24.4842 4.37791 24.4838 4.38394 24.4834C4.57368 24.4699 4.70438 24.4605 4.85841 24.4085C5.01385 24.356 5.21524 24.2507 5.49744 24.0094C5.66532 23.8658 5.91782 23.8855 6.06141 24.0533Z",
    fill: "url(#paint42_radial_715_15663)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9386 24.0533C25.795 24.2212 25.8147 24.4737 25.9826 24.6173C26.3215 24.9072 26.6103 25.0734 26.8855 25.1664C27.1394 25.2522 27.363 25.2677 27.5405 25.2801C27.553 25.2809 27.5653 25.2818 27.5773 25.2826C27.7977 25.2984 27.9891 25.1325 28.0048 24.9121C28.0206 24.6918 27.8547 24.5004 27.6343 24.4847C27.6282 24.4842 27.6221 24.4838 27.6161 24.4834C27.4263 24.4699 27.2956 24.4605 27.1416 24.4085C26.9861 24.356 26.7848 24.2507 26.5026 24.0094C26.3347 23.8658 26.0822 23.8855 25.9386 24.0533Z",
    fill: "url(#paint43_radial_715_15663)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.93791 24.1588C7.07798 24.3297 7.05306 24.5817 6.88223 24.7218C6.31663 25.1856 5.94782 25.373 5.68906 25.5044C5.66385 25.5173 5.63968 25.5295 5.61647 25.5415C5.42008 25.6427 5.17887 25.5655 5.0777 25.3691C4.97653 25.1727 5.05372 24.9315 5.2501 24.8303C5.27416 24.8179 5.29879 24.8054 5.32416 24.7925C5.56689 24.6693 5.87595 24.5124 6.37497 24.1032C6.54579 23.9631 6.79783 23.988 6.93791 24.1588Z",
    fill: "url(#paint44_radial_715_15663)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0621 24.1588C24.922 24.3297 24.9469 24.5817 25.1178 24.7218C25.6834 25.1856 26.0522 25.373 26.3109 25.5044C26.3362 25.5173 26.3603 25.5295 26.3835 25.5415C26.5799 25.6427 26.8211 25.5655 26.9223 25.3691C27.0235 25.1727 26.9463 24.9315 26.7499 24.8303C26.7258 24.8179 26.7012 24.8054 26.6758 24.7925C26.4331 24.6693 26.1241 24.5124 25.625 24.1032C25.4542 23.9631 25.2022 23.988 25.0621 24.1588Z",
    fill: "url(#paint45_radial_715_15663)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_715_15663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0179 8.52961C13.58 8.52961 14.0357 8.0739 14.0357 7.51175C14.0357 6.94961 13.58 6.4939 13.0179 6.4939C12.4557 6.4939 12 6.94961 12 7.51175C12 8.0739 12.4557 8.52961 13.0179 8.52961Z",
    fill: "url(#paint46_linear_715_15663)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_715_15663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0354 8.52961C19.5976 8.52961 20.0533 8.0739 20.0533 7.51175C20.0533 6.94961 19.5976 6.4939 19.0354 6.4939C18.4733 6.4939 18.0176 6.94961 18.0176 7.51175C18.0176 8.0739 18.4733 8.52961 19.0354 8.52961Z",
    fill: "url(#paint47_radial_715_15663)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_715_15663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0349 8.19117C19.4102 8.19117 19.7144 7.88697 19.7144 7.51172C19.7144 7.13647 19.4102 6.83228 19.0349 6.83228C18.6597 6.83228 18.3555 7.13647 18.3555 7.51172C18.3555 7.88697 18.6597 8.19117 19.0349 8.19117Z",
    fill: "#FFCA38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0349 8.19117C19.4102 8.19117 19.7144 7.88697 19.7144 7.51172C19.7144 7.13647 19.4102 6.83228 19.0349 6.83228C18.6597 6.83228 18.3555 7.13647 18.3555 7.51172C18.3555 7.88697 18.6597 8.19117 19.0349 8.19117Z",
    fill: "url(#paint48_radial_715_15663)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_715_15663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.031 8.19117C13.4063 8.19117 13.7105 7.88697 13.7105 7.51172C13.7105 7.13647 13.4063 6.83228 13.031 6.83228C12.6558 6.83228 12.3516 7.13647 12.3516 7.51172C12.3516 7.88697 12.6558 8.19117 13.031 8.19117Z",
    fill: "#E28527"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.031 8.19117C13.4063 8.19117 13.7105 7.88697 13.7105 7.51172C13.7105 7.13647 13.4063 6.83228 13.031 6.83228C12.6558 6.83228 12.3516 7.13647 12.3516 7.51172C12.3516 7.88697 12.6558 8.19117 13.031 8.19117Z",
    fill: "url(#paint49_radial_715_15663)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_715_15663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.763 6.71314H12.7708L12.7643 6.54533L12.7578 6.35171C12.7708 5.75148 13.1211 5.51913 13.2703 5.44168C13.28 5.43846 13.2914 5.43362 13.3027 5.42877C13.3141 5.42393 13.3254 5.41909 13.3351 5.41587C13.6725 5.26097 13.9449 4.9899 14.0876 4.63492L14.1395 4.5123C14.1914 4.38967 14.3536 4.37031 14.4314 4.48003C14.8855 5.1448 15.6445 5.53849 16.4488 5.53849H18.4857C18.5996 5.53849 19.1703 5.59376 19.2042 6.3812L19.1291 8.32511C19.0511 10.0979 17.6667 11.2883 15.9769 11.2883C14.287 11.2883 12.9026 10.0979 12.8246 8.32511L12.763 6.71314Z",
    fill: "url(#paint50_radial_715_15663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.763 6.71314H12.7708L12.7643 6.54533L12.7578 6.35171C12.7708 5.75148 13.1211 5.51913 13.2703 5.44168C13.28 5.43846 13.2914 5.43362 13.3027 5.42877C13.3141 5.42393 13.3254 5.41909 13.3351 5.41587C13.6725 5.26097 13.9449 4.9899 14.0876 4.63492L14.1395 4.5123C14.1914 4.38967 14.3536 4.37031 14.4314 4.48003C14.8855 5.1448 15.6445 5.53849 16.4488 5.53849H18.4857C18.5996 5.53849 19.1703 5.59376 19.2042 6.3812L19.1291 8.32511C19.0511 10.0979 17.6667 11.2883 15.9769 11.2883C14.287 11.2883 12.9026 10.0979 12.8246 8.32511L12.763 6.71314Z",
    fill: "url(#paint51_radial_715_15663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.763 6.71314H12.7708L12.7643 6.54533L12.7578 6.35171C12.7708 5.75148 13.1211 5.51913 13.2703 5.44168C13.28 5.43846 13.2914 5.43362 13.3027 5.42877C13.3141 5.42393 13.3254 5.41909 13.3351 5.41587C13.6725 5.26097 13.9449 4.9899 14.0876 4.63492L14.1395 4.5123C14.1914 4.38967 14.3536 4.37031 14.4314 4.48003C14.8855 5.1448 15.6445 5.53849 16.4488 5.53849H18.4857C18.5996 5.53849 19.1703 5.59376 19.2042 6.3812L19.1291 8.32511C19.0511 10.0979 17.6667 11.2883 15.9769 11.2883C14.287 11.2883 12.9026 10.0979 12.8246 8.32511L12.763 6.71314Z",
    fill: "url(#paint52_radial_715_15663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.763 6.71314H12.7708L12.7643 6.54533L12.7578 6.35171C12.7708 5.75148 13.1211 5.51913 13.2703 5.44168C13.28 5.43846 13.2914 5.43362 13.3027 5.42877C13.3141 5.42393 13.3254 5.41909 13.3351 5.41587C13.6725 5.26097 13.9449 4.9899 14.0876 4.63492L14.1395 4.5123C14.1914 4.38967 14.3536 4.37031 14.4314 4.48003C14.8855 5.1448 15.6445 5.53849 16.4488 5.53849H18.4857C18.5996 5.53849 19.1703 5.59376 19.2042 6.3812L19.1291 8.32511C19.0511 10.0979 17.6667 11.2883 15.9769 11.2883C14.287 11.2883 12.9026 10.0979 12.8246 8.32511L12.763 6.71314Z",
    fill: "url(#paint53_radial_715_15663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.763 6.71314H12.7708L12.7643 6.54533L12.7578 6.35171C12.7708 5.75148 13.1211 5.51913 13.2703 5.44168C13.28 5.43846 13.2914 5.43362 13.3027 5.42877C13.3141 5.42393 13.3254 5.41909 13.3351 5.41587C13.6725 5.26097 13.9449 4.9899 14.0876 4.63492L14.1395 4.5123C14.1914 4.38967 14.3536 4.37031 14.4314 4.48003C14.8855 5.1448 15.6445 5.53849 16.4488 5.53849H18.4857C18.5996 5.53849 19.1703 5.59376 19.2042 6.3812L19.1291 8.32511C19.0511 10.0979 17.6667 11.2883 15.9769 11.2883C14.287 11.2883 12.9026 10.0979 12.8246 8.32511L12.763 6.71314Z",
    fill: "url(#paint54_radial_715_15663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.763 6.71314H12.7708L12.7643 6.54533L12.7578 6.35171C12.7708 5.75148 13.1211 5.51913 13.2703 5.44168C13.28 5.43846 13.2914 5.43362 13.3027 5.42877C13.3141 5.42393 13.3254 5.41909 13.3351 5.41587C13.6725 5.26097 13.9449 4.9899 14.0876 4.63492L14.1395 4.5123C14.1914 4.38967 14.3536 4.37031 14.4314 4.48003C14.8855 5.1448 15.6445 5.53849 16.4488 5.53849H18.4857C18.5996 5.53849 19.1703 5.59376 19.2042 6.3812L19.1291 8.32511C19.0511 10.0979 17.6667 11.2883 15.9769 11.2883C14.287 11.2883 12.9026 10.0979 12.8246 8.32511L12.763 6.71314Z",
    fill: "url(#paint55_radial_715_15663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.763 6.71314H12.7708L12.7643 6.54533L12.7578 6.35171C12.7708 5.75148 13.1211 5.51913 13.2703 5.44168C13.28 5.43846 13.2914 5.43362 13.3027 5.42877C13.3141 5.42393 13.3254 5.41909 13.3351 5.41587C13.6725 5.26097 13.9449 4.9899 14.0876 4.63492L14.1395 4.5123C14.1914 4.38967 14.3536 4.37031 14.4314 4.48003C14.8855 5.1448 15.6445 5.53849 16.4488 5.53849H18.4857C18.5996 5.53849 19.1703 5.59376 19.2042 6.3812L19.1291 8.32511C19.0511 10.0979 17.6667 11.2883 15.9769 11.2883C14.287 11.2883 12.9026 10.0979 12.8246 8.32511L12.763 6.71314Z",
    fill: "url(#paint56_radial_715_15663)"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M12.763 6.71314H12.7708L12.7643 6.54533L12.7578 6.35171C12.7708 5.75148 13.1211 5.51913 13.2703 5.44168C13.28 5.43846 13.2914 5.43362 13.3027 5.42877C13.3141 5.42393 13.3254 5.41909 13.3351 5.41587C13.6725 5.26097 13.9449 4.9899 14.0876 4.63492L14.1395 4.5123C14.1914 4.38967 14.3536 4.37031 14.4314 4.48003C14.8855 5.1448 15.6445 5.53849 16.4488 5.53849H18.4857C18.5996 5.53849 19.1703 5.59376 19.2042 6.3812L19.1291 8.32511C19.0511 10.0979 17.6667 11.2883 15.9769 11.2883C14.287 11.2883 12.9026 10.0979 12.8246 8.32511L12.763 6.71314Z",
    fill: "url(#paint57_radial_715_15663)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_715_15663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7333 7.3708L15.3009 8.44617C15.2322 8.66737 15.3969 8.88856 15.6302 8.88856H16.1276C16.3609 8.88856 16.5256 8.66396 16.457 8.44617L16.1208 7.3708C16.0487 7.13259 15.8087 7.13259 15.7333 7.3708Z",
    fill: "#EB8B29"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_715_15663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7406 7.2834L15.4044 8.35876C15.3358 8.57996 15.5004 8.80116 15.7337 8.80116H16.2311C16.4644 8.80116 16.6291 8.57656 16.5605 8.35876L16.2243 7.2834C16.1522 7.04518 15.816 7.04518 15.7406 7.2834Z",
    fill: "url(#paint58_linear_715_15663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7406 7.2834L15.4044 8.35876C15.3358 8.57996 15.5004 8.80116 15.7337 8.80116H16.2311C16.4644 8.80116 16.6291 8.57656 16.5605 8.35876L16.2243 7.2834C16.1522 7.04518 15.816 7.04518 15.7406 7.2834Z",
    fill: "url(#paint59_radial_715_15663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7406 7.2834L15.4044 8.35876C15.3358 8.57996 15.5004 8.80116 15.7337 8.80116H16.2311C16.4644 8.80116 16.6291 8.57656 16.5605 8.35876L16.2243 7.2834C16.1522 7.04518 15.816 7.04518 15.7406 7.2834Z",
    fill: "url(#paint60_linear_715_15663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7406 7.2834L15.4044 8.35876C15.3358 8.57996 15.5004 8.80116 15.7337 8.80116H16.2311C16.4644 8.80116 16.6291 8.57656 16.5605 8.35876L16.2243 7.2834C16.1522 7.04518 15.816 7.04518 15.7406 7.2834Z",
    fill: "url(#paint61_linear_715_15663)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_715_15663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9819 9.35361C15.6525 9.35361 15.3429 9.27432 15.0827 9.13556C14.9937 9.0893 14.8982 9.19172 14.9542 9.27432C15.1716 9.6113 15.5504 9.83596 15.9819 9.83596C16.4134 9.83596 16.7922 9.6113 17.0096 9.27432C17.0656 9.18842 16.9701 9.0893 16.8812 9.13556C16.621 9.27432 16.3146 9.35361 15.9819 9.35361Z",
    stroke: "url(#paint62_linear_715_15663)",
    strokeWidth: 0.2
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9819 9.35361C15.6525 9.35361 15.3429 9.27432 15.0827 9.13556C14.9937 9.0893 14.8982 9.19172 14.9542 9.27432C15.1716 9.6113 15.5504 9.83596 15.9819 9.83596C16.4134 9.83596 16.7922 9.6113 17.0096 9.27432C17.0656 9.18842 16.9701 9.0893 16.8812 9.13556C16.621 9.27432 16.3146 9.35361 15.9819 9.35361Z",
    fill: "#8A004F"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_i_715_15663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.832 6.38722L13.8292 6.38882C13.8291 6.38887 13.829 6.38892 13.8289 6.38897C13.7486 6.4369 13.6446 6.41086 13.5964 6.33064C13.5482 6.2503 13.5744 6.14603 13.6547 6.09783L13.6551 6.09761L13.6557 6.09722L13.6576 6.09612L13.6636 6.09268C13.6685 6.08985 13.6754 6.08599 13.6841 6.08128C13.7015 6.07186 13.7262 6.05898 13.7574 6.0441C13.8198 6.01439 13.9086 5.97634 14.0169 5.94179C14.2319 5.87317 14.5325 5.81545 14.8571 5.87272C14.9494 5.88901 15.011 5.977 14.9947 6.06927C14.9784 6.16153 14.8904 6.22313 14.7981 6.20685C14.5459 6.16233 14.3037 6.2064 14.12 6.26501C14.029 6.29407 13.9545 6.32601 13.9034 6.35037C13.8779 6.36252 13.8584 6.37271 13.8457 6.37959L13.832 6.38722Z",
    fill: "#BD4F26"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_i_715_15663)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3426 6.09783C18.3426 6.09786 18.3427 6.09789 18.2554 6.24336L18.3426 6.09783C18.4229 6.14603 18.4491 6.2503 18.4009 6.33064C18.3527 6.41087 18.2487 6.43696 18.1684 6.38902C18.1684 6.38899 18.1683 6.38893 18.1681 6.38884L18.1653 6.38722C18.1625 6.38562 18.1579 6.38302 18.1516 6.37959C18.1389 6.37271 18.1194 6.36252 18.0939 6.35037C18.0427 6.32601 17.9683 6.29407 17.8772 6.26501C17.6936 6.2064 17.4514 6.16233 17.1992 6.20685C17.1069 6.22313 17.0189 6.16153 17.0026 6.06927C16.9863 5.977 17.0479 5.88901 17.1402 5.87272C17.4647 5.81545 17.7654 5.87317 17.9804 5.94179C18.0887 5.97634 18.1775 6.01439 18.2398 6.0441C18.2711 6.05898 18.2958 6.07186 18.3132 6.08128C18.3219 6.08599 18.3288 6.08985 18.3337 6.09268L18.3397 6.09612L18.3415 6.09722L18.3422 6.09761L18.3426 6.09783Z",
    fill: "#BD4F26"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_715_15663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.209 6.01085C17.413 5.96122 17.9204 5.98603 18.2595 6.22868",
    stroke: "#C9725D",
    strokeWidth: 0.1,
    strokeLinecap: "round"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_f_715_15663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8105 6.01085C14.6065 5.96122 14.0992 5.98603 13.76 6.22868",
    stroke: "#C9725D",
    strokeWidth: 0.1,
    strokeLinecap: "round"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_f_715_15663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8855 3.70751C13.2784 3.35762 13.8451 3.35408 14.1632 3.41063L14.4176 4.22704C14.255 4.2023 14.1101 4.25884 13.9882 4.37547C13.6998 5.17279 12.7088 5.61245 12.2494 5.73261C12.154 4.78898 12.207 4.31186 12.8855 3.70751Z",
    fill: "url(#paint63_radial_715_15663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8855 3.70751C13.2784 3.35762 13.8451 3.35408 14.1632 3.41063L14.4176 4.22704C14.255 4.2023 14.1101 4.25884 13.9882 4.37547C13.6998 5.17279 12.7088 5.61245 12.2494 5.73261C12.154 4.78898 12.207 4.31186 12.8855 3.70751Z",
    fill: "url(#paint64_radial_715_15663)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_f_715_15663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5996 2.58364C14.8831 2.42545 14.1152 3.18799 14.041 3.45306C15.0165 5.74324 16.5143 5.52498 18.1761 5.34033C19.1708 5.2298 19.2787 5.68315 19.3636 5.90227C19.0879 3.33643 17.2324 2.94413 15.5996 2.58364Z",
    fill: "url(#paint65_radial_715_15663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5996 2.58364C14.8831 2.42545 14.1152 3.18799 14.041 3.45306C15.0165 5.74324 16.5143 5.52498 18.1761 5.34033C19.1708 5.2298 19.2787 5.68315 19.3636 5.90227C19.0879 3.33643 17.2324 2.94413 15.5996 2.58364Z",
    fill: "url(#paint66_radial_715_15663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5996 2.58364C14.8831 2.42545 14.1152 3.18799 14.041 3.45306C15.0165 5.74324 16.5143 5.52498 18.1761 5.34033C19.1708 5.2298 19.2787 5.68315 19.3636 5.90227C19.0879 3.33643 17.2324 2.94413 15.5996 2.58364Z",
    fill: "url(#paint67_radial_715_15663)"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_f_715_15663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1523 3.37354C14.1671 3.52727 14.3008 4.10512 14.4969 4.45501",
    stroke: "url(#paint68_linear_715_15663)",
    strokeWidth: 0.1,
    strokeLinecap: "round"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9336 7.23901C14.0039 7.3536 14.2367 7.58276 14.6055 7.58276C14.9023 7.58276 15.1966 7.3536 15.2617 7.23901",
    stroke: "#A83B3E",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_f_715_15663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9336 7.23901C14.0039 7.3536 14.2367 7.58276 14.6055 7.58276C14.9023 7.58276 15.1966 7.3536 15.2617 7.23901",
    stroke: "#BB614F",
    strokeWidth: 0.1,
    strokeLinecap: "round"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7227 7.23901C16.793 7.3536 17.0258 7.58276 17.3945 7.58276C17.6914 7.58276 17.9857 7.3536 18.0508 7.23901",
    stroke: "#A83B3E",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_f_715_15663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7227 7.23901C16.793 7.3536 17.0258 7.58276 17.3945 7.58276C17.6914 7.58276 17.9857 7.3536 18.0508 7.23901",
    stroke: "#BB614F",
    strokeWidth: 0.1,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_715_15663",
    x: 11.2324,
    y: 1.86719,
    width: 9.75,
    height: 9.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25,
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.92549 0 0 0 0 0.537255 0 0 0 0 0.12549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_15663"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_715_15663",
    x: 17.5898,
    y: 21.8875,
    width: 9.72852,
    height: 6.15625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.960784 0 0 0 0 0.647059 0 0 0 0 0.219608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_15663"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.803922 0 0 0 0 0.478431 0 0 0 0 0.368627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_715_15663",
    result: "effect2_innerShadow_715_15663"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_715_15663",
    x: 5.71484,
    y: 21.8875,
    width: 17.2129,
    height: 7.99536,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.960784 0 0 0 0 0.647059 0 0 0 0 0.219608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_15663"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.803922 0 0 0 0 0.478431 0 0 0 0 0.368627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_715_15663",
    result: "effect2_innerShadow_715_15663"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_715_15663",
    x: 11.832,
    y: 21.2292,
    width: 8.50078,
    height: 3.1895,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2,
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.470588 0 0 0 0 0.360784 0 0 0 0 0.266667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_15663"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_715_15663",
    x: 12,
    y: 6.4939,
    width: 2.13516,
    height: 2.03564,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.768627 0 0 0 0 0.501961 0 0 0 0 0.160784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_15663"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_715_15663",
    x: 18.0176,
    y: 6.2439,
    width: 2.03516,
    height: 2.28564,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.937255 0 0 0 0 0.576471 0 0 0 0 0.341176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_15663"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_715_15663",
    x: 17.8555,
    y: 6.33228,
    width: 2.35938,
    height: 2.35889,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_715_15663"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_715_15663",
    x: 12.1016,
    y: 6.58228,
    width: 1.85938,
    height: 1.85889,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_715_15663"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_715_15663",
    x: 12.7578,
    y: 4.40796,
    width: 6.44727,
    height: 7.28037,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.92549 0 0 0 0 0.529412 0 0 0 0 0.137255 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_15663"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_715_15663",
    x: 14.7852,
    y: 6.69214,
    width: 2.1875,
    height: 2.69653,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_715_15663"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_715_15663",
    x: 15.2387,
    y: 6.95474,
    width: 1.4875,
    height: 1.99653,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075,
    result: "effect1_foregroundBlur_715_15663"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_715_15663",
    x: 14.7379,
    y: 8.92368,
    width: 2.48906,
    height: 1.11235,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_715_15663"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_i_715_15663",
    x: 13.5723,
    y: 5.64937,
    width: 1.62578,
    height: 0.763721,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2,
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.658824 0 0 0 0 0.270588 0 0 0 0 0.141176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_15663"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_i_715_15663",
    x: 17,
    y: 5.64937,
    width: 1.62578,
    height: 0.763721,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2,
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.658824 0 0 0 0 0.270588 0 0 0 0 0.141176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_15663"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_715_15663",
    x: 17.0582,
    y: 5.8397,
    width: 1.35039,
    height: 0.538867,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_715_15663"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_715_15663",
    x: 13.6109,
    y: 5.8397,
    width: 1.35039,
    height: 0.538867,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_715_15663"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_f_715_15663",
    x: 11.4629,
    y: 2.63354,
    width: 3.70508,
    height: 3.84912,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375,
    result: "effect1_foregroundBlur_715_15663"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_f_715_15663",
    x: 13.891,
    y: 2.41226,
    width: 5.62227,
    height: 3.64009,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075,
    result: "effect1_foregroundBlur_715_15663"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_f_715_15663",
    x: 13.8516,
    y: 3.07349,
    width: 0.945312,
    height: 1.68164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_715_15663"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_f_715_15663",
    x: 13.7828,
    y: 7.08896,
    width: 1.62969,
    height: 0.643848,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_715_15663"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_f_715_15663",
    x: 16.5719,
    y: 7.08896,
    width: 1.62969,
    height: 0.643848,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_715_15663"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_715_15663",
    x1: 18.9512,
    y1: 3.11385,
    x2: 14.3706,
    y2: 11.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD93C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E37923"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.4007 9.59854) rotate(28.3008) scale(2.01761 2.85784)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.616274,
    stopColor: "#E38923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E38923",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.0909 8.79817) rotate(90) scale(2.81901 1.69836)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9641B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D77117",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.9824 8.85673) rotate(90) scale(3.52403 3.67091)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.617268,
    stopColor: "#E26B25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E26B25",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.8762 7.71473) rotate(127.617) scale(1.28585 1.24849)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161391,
    stopColor: "#C9681C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9681C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.25 6.1734) rotate(100.537) scale(1.61741 1.68423)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.365444,
    stopColor: "#D76A18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D76A18",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.8717 2.9808) rotate(62.6046) scale(1.50612 2.86913)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.221806,
    stopColor: "#CBA140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921111,
    stopColor: "#CBA140",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.4601 3.87724) rotate(132.51) scale(1.03559 1.44722)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDF3C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.7324 6.97321) rotate(163.779) scale(1.21459 2.64279)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD336",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD537",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.5457 11.8903) rotate(-133.315) scale(2.94913 4.23529)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB6325"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB6325",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.2714 4.55879) rotate(-90.3515) scale(0.869395 0.285046)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.295258,
    stopColor: "#DB6009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB6009",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.52553 22.9339) rotate(-165.38) scale(1.11282 0.719115)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0965224,
    stopColor: "#FDC021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.819839,
    stopColor: "#EEB232"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.4745 22.9339) rotate(-14.6195) scale(1.11282 0.719115)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0965224,
    stopColor: "#FDC021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.819839,
    stopColor: "#EEB232"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.3184 25.2937) rotate(-180) scale(4.10352 6.94644)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0BE37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE23"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.4961 23.9187) rotate(71.3421) scale(2.53972 2.68299)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D67D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1A516",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.83984 28.6375) rotate(15.4885) scale(2.69149 1.96589)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.270372,
    stopColor: "#DF9538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C57645"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.70703 27.7312) rotate(95.9389) scale(2.34069 0.964569)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8A451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A451",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.4961 26.3851) rotate(162.441) scale(1.1472 5.93915)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.206073,
    stopColor: "#FFCF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.08984 24.1687) rotate(52.267) scale(3.31913 2.75628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.145732,
    stopColor: "#E29612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB330",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.4961 23.2) scale(4.5 1.90625)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5A12B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA801C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_715_15663",
    x1: 21.4883,
    y1: 21.1375,
    x2: 21.4883,
    y2: 22.2937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB5D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7E09",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_715_15663",
    x1: 18.6211,
    y1: 24.4218,
    x2: 19.8555,
    y2: 24.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.106403,
    stopColor: "#B36722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E79B22",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.18359 23.3562) scale(4.40625 2.88047)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.141844,
    stopColor: "#FBB22C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4861A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_715_15663",
    x1: 10.7852,
    y1: 21.1375,
    x2: 10.7852,
    y2: 22.2937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB5D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7E09",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_715_15663",
    x1: 13.6523,
    y1: 24.4218,
    x2: 12.418,
    y2: 24.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.106403,
    stopColor: "#B36722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E79B22",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_715_15663",
    x1: 12.2017,
    y1: 20.7429,
    x2: 9.99517,
    y2: 20.5523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.184099,
    stopColor: "#E08113"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08113",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.11963 23.6011) rotate(-40.9891) scale(6.04437 2.04942)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.267882,
    stopColor: "#FFDA3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDA3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.2017 20.1062) rotate(117.54) scale(3.48912 1.17492)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B310C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D17602",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_715_15663",
    x1: 19.7983,
    y1: 20.7429,
    x2: 22.0048,
    y2: 20.5523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.184099,
    stopColor: "#E08113"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08113",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.7983 20.1062) rotate(62.4596) scale(3.48912 1.17492)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B310C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D17602",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.9019 24.9187) rotate(-121.715) scale(3.26947 3.36536)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.353006,
    stopColor: "#FED43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC938",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.4331 13.2) rotate(63.519) scale(9.53125 4.36739)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDA44",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.4023 21.2) rotate(99.6783) scale(4.08945 8.51713)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125919,
    stopColor: "#A99CA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925256,
    stopColor: "#8C7778"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.5898 13.4812) rotate(-128.1) scale(3.49455 5.00001)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4AD2B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.6699 9.88745) rotate(66.1941) scale(2.32261 2.81481)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.574476,
    stopColor: "#CD7B01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF9514",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.6523 13.3876) rotate(87.3481) scale(10.5113 6.23292)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0558287,
    stopColor: "#987FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7455B7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.1401 14.6376) rotate(141.869) scale(10.274 13.0752)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.406814,
    stopColor: "#7054AB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#613D5C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.5898 11.9188) rotate(28.8108) scale(4.27977 11.6803)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0735765,
    stopColor: "#785684"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#735EA4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.58936 23.247) rotate(172.928) scale(2.01154 0.844909)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.300197,
    stopColor: "#FAC537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAA33B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.4106 23.247) rotate(7.0721) scale(2.01154 0.844909)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.300197,
    stopColor: "#FAC537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAA33B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.72217 23.7314) rotate(167.535) scale(2.28031 0.668404)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.300197,
    stopColor: "#FDD33C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAA33B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.2778 23.7314) rotate(12.4649) scale(2.28031 0.668404)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.300197,
    stopColor: "#FDD33C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAA33B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.94092 24.1297) rotate(151.199) scale(2.2216 0.56849)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.300197,
    stopColor: "#FFDB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAA33B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.0591 24.1297) rotate(28.8014) scale(2.2216 0.56849)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.300197,
    stopColor: "#FFDB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAA33B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.67139 24.1507) rotate(143.988) scale(2.19243 1.27494)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.300197,
    stopColor: "#FFDB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECA037"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.3286 24.1507) rotate(36.0124) scale(2.19243 1.27494)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.300197,
    stopColor: "#FFDB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECA037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_715_15663",
    x1: 12,
    y1: 7.56689,
    x2: 13.872,
    y2: 7.56689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B96201"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.5372 7.78955) rotate(-24.444) scale(1.72952 2.11166)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.572298,
    stopColor: "#FFC531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904617,
    stopColor: "#FFE549"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.8865 7.66229) rotate(-20.2976) scale(0.825238)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.71002,
    stopColor: "#FFBA25",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA25"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.031 7.51172) rotate(180) scale(0.679447 0.649934)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.415002,
    stopColor: "#D67923",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D67923"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.7897 7.17185) rotate(155.244) scale(4.53029 6.06371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB9235"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.1831 7.61303) rotate(152.124) scale(1.50974 1.2809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE842",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.6022 11.4623) rotate(-78.3106) scale(2.61301 3.31543)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4883F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4883F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.8154 6.86591) rotate(90) scale(4.70668 7.47548)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.592664,
    stopColor: "#F3943B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D97C39"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.3779 8.21965) rotate(164.542) scale(3.55887 6.12728)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.876514,
    stopColor: "#D4993E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4993E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.4368 6.90715) rotate(-90) scale(0.72794 0.893381)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB31",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.7676 6.96229) rotate(-90) scale(0.860293 0.985953)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09429"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F09429",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.2042 7.84812) rotate(-180) scale(0.852038 2.80494)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDA39",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_715_15663",
    x1: 15.9824,
    y1: 8.80116,
    x2: 15.9824,
    y2: 7.10474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8C73F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.4786 8.30789) rotate(-105.892) scale(1.61121 0.921954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0168227,
    stopColor: "#FFE848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE848",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_715_15663",
    x1: 15.3205,
    y1: 8.31892,
    x2: 15.8609,
    y2: 8.3851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A322",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_715_15663",
    x1: 15.9824,
    y1: 8.85936,
    x2: 15.9824,
    y2: 8.47333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E48538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E48538",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_715_15663",
    x1: 15.5208,
    y1: 9.79356,
    x2: 15.807,
    y2: 9.24222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEAC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEAC35",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.2639 3.11376) rotate(129.554) scale(3.39658 1.48135)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.395696,
    stopColor: "#EE971B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911046,
    stopColor: "#D8772C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.1756 3.45998) rotate(144.458) scale(2.41211 1.1921)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.120488,
    stopColor: "#FFCA2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE134",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA2D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.1144 2.37205) rotate(115.63) scale(3.19582 4.53753)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.627022,
    stopColor: "#F49523",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49523"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.5682 3.16485) rotate(105.909) scale(2.17605 4.56032)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.131886,
    stopColor: "#FFE337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE337",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_715_15663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.7085 6.7271) rotate(-117.848) scale(4.62694 4.1362)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.897563,
    stopColor: "#CA9B37",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA9B37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_715_15663",
    x1: 14.1523,
    y1: 3.59089,
    x2: 14.4969,
    y2: 4.39669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB6008"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInLotusPosition);
export default __webpack_public_path__ + "static/media/InLotusPosition.a04043d46e1ccc4c51383d14016bf64e.svg";
export { ForwardRef as ReactComponent };